class GravityFormScroll {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        document.addEventListener('DOMContentLoaded', this.scrollToConfirmation.bind(this));
    }

    scrollToConfirmation() {
        const confirmationWrapper = document.querySelector('.gform_confirmation_wrapper');
        if (confirmationWrapper) {
            this.smoothScroll(confirmationWrapper);
            confirmationWrapper.focus();
        }
    }

    smoothScroll(targetElement) {
        const header = document.querySelector('.wp-header');
        const headerHeight = header ? header.offsetHeight : 0;
        const parentElement = targetElement.parentElement;
        const parentPosition = parentElement ? parentElement.getBoundingClientRect().top + window.pageYOffset : 0;

        const scrollToPosition = parentPosition - headerHeight - 200;

        window.scrollTo({
            top: scrollToPosition,
            behavior: 'smooth'
        });
    }
}

export default GravityFormScroll;
